import { Controller } from "@hotwired/stimulus"

// Opens a <details> element whose id matches the URL hash on connect and on
// hashchange — so sidebar anchor links expand collapsed form sections.
export default class extends Controller {
  connect() {
    this._openTargeted()
    this._handler = this._openTargeted.bind(this)
    window.addEventListener("hashchange", this._handler)
  }

  disconnect() {
    window.removeEventListener("hashchange", this._handler)
  }

  _openTargeted() {
    const id = location.hash.slice(1)
    if (!id) return
    const el = document.getElementById(id)
    if (el?.tagName === "DETAILS") el.open = true
  }
}
